import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { OAuthResponse } from '../../../core/models/authentication/auth0.model';

@Injectable({ providedIn: 'root' })
export class Auth0Service {

  public static readonly TOO_MANY_ATTEMPTS_ERROR_KEY = 'too_many_attempts';
  public static readonly UNVERIFIED_EMAIL_ERROR_KEY = 'unverified_email';

  constructor(private readonly http: HttpClient) { }

  public getPasswordGrantCredentials(email: string, password: string): Observable<OAuthResponse> {
    return this.http.post<OAuthResponse>(`${environment.auth0Config.tenantUrl}/oauth/token`, {
      client_id: `${environment.auth0Config.clientId}`,
      realm: `${environment.auth0Config.realm}`,
      username: email,
      password,
      grant_type: 'password',
      scope: `${environment.auth0Config.scope}`,
      audience: `${environment.auth0Config.audience}`
    });
  }

  public refreshToken(refreshToken: string): Observable<OAuthResponse> {
    return this.http.post<OAuthResponse>(
        `${environment.auth0Config.tenantUrl}/oauth/token`,
        {
          client_id: `${environment.auth0Config.clientId}`,
          realm: `${environment.auth0Config.realm}`,
          refresh_token: refreshToken,
          grant_type: 'refresh_token'
        });
  }

}
